import { Link } from "react-router-dom";
import { Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Typography, Box } from "@mui/material";

interface CardAdministradorProps {
    title: string;
    icon: JSX.Element;
    links: { to?: string; fun?: () => void; text: string; icon: JSX.Element }[];
    backgroundColor?: string;
    linkTextColor?: string;
}

const CardAdministrador: React.FC<CardAdministradorProps> = ({
    title,
    icon,
    links,
    backgroundColor = "#17c2e6",
}) => {
    return (
        <Box sx={{ position: "relative", display: "inline-block", width: "100%", marginBottom: "20px" }}>
            <Box
                sx={{
                    position: "absolute",
                    top: -16,
                    left: 15,
                    backgroundColor,
                    color: "white",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    boxShadow: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    height: "40px"
                }}
            >
                {icon}
                <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: 16, fontFamily: "Arial" }}>
                    {title}
                </Typography>
            </Box>
            <Card sx={{ borderRadius: 2, boxShadow: 3, paddingTop: 4, paddingX: 2, height: "95%", display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ paddingTop: 2 }}>
                    <List sx={{ paddingY: 0 }}>
                        {links.map((link, index) => {

                            if( link.to ) return (
                                <ListItem
                                    key={index}
                                    component={Link}
                                    to={link.to}
                                    sx={{
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        paddingY: 1,
                                        borderBottom: index !== links.length - 1 ? "1px solid #eee" : "none",
                                        color: "black",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        borderRadius: "8px",
                                        transition: "background-color 0.3s",
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5"
                                        }
                                    }}
                                >
                                    <ListItemIcon sx={{ minWidth: "40px" }}>{link.icon}</ListItemIcon>
                                    <ListItemText primary={link.text} slotProps={{ primary: { sx: { fontFamily: "Arial", fontSize: "0.9rem" } } }} />
                                </ListItem>
                            );

                            if(link.fun) return (
                                <ListItem
                                    key={index}
                                    onClick={link.fun}
                                    sx={{
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        paddingY: 1,
                                        borderBottom: index !== links.length - 1 ? "1px solid #eee" : "none",
                                        color: "black",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        borderRadius: "8px",
                                        transition: "background-color 0.3s",
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5"
                                        }
                                    }}
                                >
                                    <ListItemIcon sx={{ minWidth: "40px" }}>{link.icon}</ListItemIcon>
                                    <ListItemText primary={link.text} slotProps={{ primary: { sx: { fontFamily: "Arial", fontSize: "0.9rem" } } }} />
                                </ListItem>
                            )
                        })}
                    </List>
                </CardContent>
            </Card>
        </Box>
    );
};

export default CardAdministrador;
